import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	contextMenuAriaLabel: {
		id: 'software-context-menu.context-menu.context-menu-aria-label',
		defaultMessage: 'Open menu',
		description: 'Aria label for the button that opens the context menu',
	},
});
